export default __webpack_public_path__ + "static/media/flag-ita.b39d3470.svg";